module.exports = __webpack_public_path__ + "img/saude2.224641fb.svg";